export var SchoolsOrderBy = {
  areaId: 'AREA_ID',
  createdAt: 'CREATED_AT',
  'managers.createdBy.id': 'CREATOR_ID',
  'managers.modifiedBy.id': 'MODIFIER_ID',
  name: 'NAME',
  status: 'STATUS',
  updatedAt: 'UPDATED_AT'
};